import { RichEditorTemplate } from '@ametista-ai/editor/types';
import { isMarkActive } from '@ametista-ai/editor/utils';
import { useEditorState } from '@handlewithcare/react-prosemirror';
import { Button, Divider, Group } from '@mantine/core';
import { Icon } from '@/ui';
import { ListBlockMenu } from './ListBlockMenu';
import { TemplateMenu } from './TemplateMenu';
import { TextBlockMenu } from './TextBlockMenu';
import { ToggleMarkButton } from './ToggleMarkButton';

export function Toolbar({
  templates,
  rightSection,
}: {
  templates?: RichEditorTemplate[];
  rightSection?: React.ReactNode;
}) {
  const state = useEditorState();

  return (
    <Group gap="xs" justify="space-between" align="flex-start">
      <Group gap={0}>
        <TextBlockMenu />
        <Divider orientation="vertical" mx="xs" />
        <Button.Group>
          <ToggleMarkButton
            mark="strong"
            label={<Icon name="bold" />}
            active={isMarkActive(state.schema.marks['strong'], state)}
          />
          <ToggleMarkButton
            mark="em"
            label={<Icon name="italic" />}
            active={isMarkActive(state.schema.marks['em'], state)}
          />
          <ToggleMarkButton
            mark="underline"
            label={<Icon name="underline" />}
            active={isMarkActive(state.schema.marks['underline'], state)}
          />
          <ToggleMarkButton
            mark="strikethrough"
            label={<Icon name="strikethrough" />}
            active={isMarkActive(state.schema.marks['strikethrough'], state)}
          />
        </Button.Group>
        <Divider orientation="vertical" mx="xs" />
        <ListBlockMenu />
        {templates?.length && (
          <>
            <Divider orientation="vertical" mx="xs" />
            <TemplateMenu templates={templates} />
          </>
        )}
      </Group>
      {rightSection}
    </Group>
  );
}
